// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1dEUW","label":"styles_label__2dLN6"};